/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionClickDateGroupingFromJSON, ApiAttributionClickDateGroupingToJSON, } from './ApiAttributionClickDateGrouping';
import { ApiCSVUploadSessionFromJSON, ApiCSVUploadSessionToJSON, } from './ApiCSVUploadSession';
import { ApiCurrencyFromJSON, ApiCurrencyToJSON, } from './ApiCurrency';
import { ApiExternalAdFromJSON, ApiExternalAdToJSON, } from './ApiExternalAd';
import { ApiExternalAdGroupFromJSON, ApiExternalAdGroupToJSON, } from './ApiExternalAdGroup';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiMatchTypeFromJSON, ApiMatchTypeToJSON, } from './ApiMatchType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiAttributionClickFromJSON(json) {
    return ApiAttributionClickFromJSONTyped(json, false);
}
export function ApiAttributionClickFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adGroup': !exists(json, 'adGroup') ? undefined : ApiExternalAdGroupFromJSON(json['adGroup']),
        'allConversionsCount': !exists(json, 'allConversionsCount') ? undefined : json['allConversionsCount'],
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'averageSessionCost': !exists(json, 'averageSessionCost') ? undefined : json['averageSessionCost'],
        'campaign': !exists(json, 'campaign') ? undefined : json['campaign'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'conversionsCount': !exists(json, 'conversionsCount') ? undefined : json['conversionsCount'],
        'cost': !exists(json, 'cost') ? undefined : json['cost'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'csvUploadSessionId': !exists(json, 'csvUploadSessionId') ? undefined : json['csvUploadSessionId'],
        'currency': !exists(json, 'currency') ? undefined : ApiCurrencyFromJSON(json['currency']),
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'dateGrouping': !exists(json, 'dateGrouping') ? undefined : ApiAttributionClickDateGroupingFromJSON(json['dateGrouping']),
        'externalAd': !exists(json, 'externalAd') ? undefined : ApiExternalAdFromJSON(json['externalAd']),
        'externalAdGroupId': !exists(json, 'externalAdGroupId') ? undefined : json['externalAdGroupId'],
        'externalAdId': !exists(json, 'externalAdId') ? undefined : json['externalAdId'],
        'externalCampaign': !exists(json, 'externalCampaign') ? undefined : ApiExternalCampaignFromJSON(json['externalCampaign']),
        'externalCampaignId': !exists(json, 'externalCampaignId') ? undefined : json['externalCampaignId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'impressions': !exists(json, 'impressions') ? undefined : json['impressions'],
        'matchType': !exists(json, 'matchType') ? undefined : ApiMatchTypeFromJSON(json['matchType']),
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'revenue': !exists(json, 'revenue') ? undefined : json['revenue'],
        'sales': !exists(json, 'sales') ? undefined : json['sales'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceId': !exists(json, 'sourceId') ? undefined : json['sourceId'],
        'sync': !exists(json, 'sync') ? undefined : ApiCSVUploadSessionFromJSON(json['sync']),
        'syncId': !exists(json, 'syncId') ? undefined : json['syncId'],
        'term': !exists(json, 'term') ? undefined : json['term'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'uploadSession': !exists(json, 'uploadSession') ? undefined : ApiCSVUploadSessionFromJSON(json['uploadSession']),
    };
}
export function ApiAttributionClickToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adGroup': ApiExternalAdGroupToJSON(value.adGroup),
        'allConversionsCount': value.allConversionsCount,
        'analyticsSynced': value.analyticsSynced,
        'averageSessionCost': value.averageSessionCost,
        'campaign': value.campaign,
        'content': value.content,
        'conversionsCount': value.conversionsCount,
        'cost': value.cost,
        'count': value.count,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'csvUploadSessionId': value.csvUploadSessionId,
        'currency': ApiCurrencyToJSON(value.currency),
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'dateGrouping': ApiAttributionClickDateGroupingToJSON(value.dateGrouping),
        'externalAd': ApiExternalAdToJSON(value.externalAd),
        'externalAdGroupId': value.externalAdGroupId,
        'externalAdId': value.externalAdId,
        'externalCampaign': ApiExternalCampaignToJSON(value.externalCampaign),
        'externalCampaignId': value.externalCampaignId,
        'id': value.id,
        'impressions': value.impressions,
        'matchType': ApiMatchTypeToJSON(value.matchType),
        'medium': value.medium,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'revenue': value.revenue,
        'sales': value.sales,
        'source': value.source,
        'sourceId': value.sourceId,
        'sync': ApiCSVUploadSessionToJSON(value.sync),
        'syncId': value.syncId,
        'term': value.term,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'uploadSession': ApiCSVUploadSessionToJSON(value.uploadSession),
    };
}
